import { FC } from "react";

import { Stack } from "@mui/material";

import type { OrganizationApprovalDescription } from "../helpers/useOrganizationApprovalDescription";

import { HandoffDetails } from "./HandoffDetails/HandoffDetails";
import { ResendDetails } from "./ResendDetails/ResendDetails";
import { SalesDetails } from "./SalesDetails/SalesDetails";

interface ApprovalDetailsProps {
  description: OrganizationApprovalDescription;
}

export const ApprovalDetails: FC<ApprovalDetailsProps> = ({ description }) => {
  if (description.kind === "unknown") {
    return null;
  }
  if (description.kind === "resend" && !description.card) {
    return null;
  }
  if (description.kind === "sales" && !description.card.formName) {
    return null;
  }
  return (
    <Stack component="dl" spacing={1.5} sx={{ m: 0 }}>
      {description.kind === "handoff" && <HandoffDetails card={description.card} />}
      {description.kind === "resend" && description.card && <ResendDetails card={description.card} />}
      {description.kind === "sales" && description.card.formName && (
        <SalesDetails formName={description.card.formName} />
      )}
    </Stack>
  );
};
